import { AttendanceProjectType, mapAttendanceProjectType } from "./AttendanceProjectType";

export interface AttendanceInfoType {
    id?: number;
    contact_id?: number;
    personal_info_id?: number;
    project_id?: number;
    attendance_date?: string;
    status?: 'Present' | 'Absent' | 'Halfday';
    project_data?: AttendanceProjectType | null;
}


// to single object maping
export const mapAttendanceInfoType = (data: any): AttendanceInfoType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: AttendanceInfoType = {
        id: data.id,
        contact_id: data.contact_id,
        personal_info_id: data.personal_info_id,
        project_id: data.project_id,
        attendance_date: data.attendance_date,
        status: data.status,
        project_data: (data.project_data !== null) ? mapAttendanceProjectType(data.project_data) : null,
    }
    return res;
}

// maping list objects
export const mapAttendanceInfoTypes = (data: any[]): AttendanceInfoType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapAttendanceInfoType);
}